import OnboardingTutorialContent from './onboarding-tutorial-content'

export default OnboardingTutorialContent
